import { Component, OnInit} from '@angular/core';
import {ObjectNames, MenuItems} from '../constants/constants';
import {CustomService} from './custom.service';

@Component({
  selector: 'app-custom',
  templateUrl: './custom.component.html',
  styleUrls: ['./custom.component.scss']
})
export class CustomComponent implements OnInit {

  configMenuCustomItems:any[];
  index:number=0;
  modules=[];

  constructor(private customService: CustomService) { }

  ngOnInit(): void {
    this.configMenuCustomItems = [
      {
        label: MenuItems.List,
        icon: 'pi pi-plus',
        command: () => {
          this.showAddCustomField();
        }
      }
    ]
  }

  getIndex(event){
    this.index = event.index;
  }

  showAddCustomField(){
    this.index=0;
    this.customService.setCustom(ObjectNames.BehaviorSubjectVariable);
  }

  showAddCustomSection(){
    this.index=1;
    this.customService.setSection(ObjectNames.BehaviorSubjectVariable);
  }

  getModules() {
    this.customService.getAllModules().subscribe(modules => {
      this.modules = modules;
    });
  }

  // ngOnDestroy(){
  //   this.customService.setCustom('');
  //   this.customService.setSection('');
  // }

}
